<div class="chart-container">
  <div [attr.id]="chartContainer" ></div>
</div>